<template lang="pug">
  #header
    img(:src="imagePath + 'img/logo.png'" @click="go_top")
</template>


<script lang="js">
import FamilyTree from '@/components/page/FamilyTree.vue';

export default {

  computed: {
    imagePath() {
      return process.env.BASE_URL;
    },
  },
  methods: {
    go_top() {
      location.href = '/';
    },
  },
};
</script>

<style lang="sass" scoped>
#header
  padding: 12px 30px
  height: 88px
  img
    width: 171px
    cursor: pointer
@media screen and (max-width: $break-header)
  #header
    padding: 15px
    height: auto
    background-color: $header-background-color
</style>